module.exports = {
  async getFloorSpots(floorId, params) {
    const url = `${this.url}/${this.version}/floors/${floorId}/spots`;
    const response = await this.get(url, params, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/floor_spots_api.js